import { useIntl } from "react-intl";

import { getTravelerType } from "@/features/travellers/utils/transformTraveler";

export function TravelerTypeLabel(props: { birthDate: string }) {
  const type = getTravelerType(props.birthDate);
  const intl = useIntl();

  if (type === "adult") {
    return intl.formatMessage({
      defaultMessage: "Adult",
      description: "Traveller type label: adult",
    });
  }

  if (type === "child") {
    return intl.formatMessage({
      defaultMessage: "Child",
      description: "Traveller type label: child",
    });
  }

  return intl.formatMessage({
    defaultMessage: "Infant",
    description: "Traveller type label: infant",
  });
}
